// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let IconV5 = require("../common/Components/IconV5.bs.js");
let DialogV5 = require("../common/Components/DialogV5.bs.js");
let ButtonsV5 = require("../common/Components/ButtonsV5.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let ShareURLMakers = require("./ShareURLMakers.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let CopyMarketingProfileLinkButton = require("./CopyMarketingProfileLinkButton.bs.js");

function ShareMarketingProfileDialog$BaseShareLink(props) {
  return JsxRuntime.jsxs("a", {
    children: [
      JsxRuntime.jsx("div", {
        children: props.children,
        className: "flex gap-4"
      }),
      JsxRuntime.jsx(IconV5.make, {
        icon: "arrow-right",
        className: "ml-2"
      })
    ],
    className: "flex justify-between py-4 px-3 hover:bg-zinc-100 rounded-lg text-zinc-700 hover:text-zinc-700 font-semibold",
    href: props.href,
    rel: "noopener noreferrer",
    target: "_blank"
  });
}

let BaseShareLink = {
  make: ShareMarketingProfileDialog$BaseShareLink
};

function ShareMarketingProfileDialog$ShareOnFacebook(props) {
  return JsxRuntime.jsx(ShareMarketingProfileDialog$BaseShareLink, {
    href: ShareURLMakers.makeFacebookShareUrl(props.url),
    children: JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsx(IconV5.make, {
          icon: "facebook",
          className: "text-blue-600 h-5 w-5"
        }),
        "Share on Facebook"
      ],
      className: "flex gap-4"
    })
  });
}

let ShareOnFacebook = {
  make: ShareMarketingProfileDialog$ShareOnFacebook
};

function ShareMarketingProfileDialog$ShareOnTwitter(props) {
  return JsxRuntime.jsx(ShareMarketingProfileDialog$BaseShareLink, {
    href: ShareURLMakers.makeTwitterShareUrl(props.url),
    children: JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsx(IconV5.make, {
          icon: "twitter",
          className: "text-blue-400 w-5 h-5"
        }),
        "Share on Twitter"
      ],
      className: "flex gap-4"
    })
  });
}

let ShareOnTwitter = {
  make: ShareMarketingProfileDialog$ShareOnTwitter
};

function makeLinkedInShareUrl(url) {
  return "https://www.linkedin.com/shareArticle?mini=true&url=" + ShareURLMakers.encodeUrl(url);
}

function ShareMarketingProfileDialog$ShareOnLinkedIn(props) {
  return JsxRuntime.jsx(ShareMarketingProfileDialog$BaseShareLink, {
    href: "https://www.linkedin.com/shareArticle?mini=true&url=" + ShareURLMakers.encodeUrl(props.url),
    children: JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsx(IconV5.make, {
          icon: "linked-in",
          className: "text-blue-600 w-5 h-5"
        }),
        "Share on LinkedIn"
      ],
      className: "flex gap-4"
    })
  });
}

let ShareOnLinkedIn = {
  makeLinkedInShareUrl: makeLinkedInShareUrl,
  make: ShareMarketingProfileDialog$ShareOnLinkedIn
};

function ShareMarketingProfileDialog$ShareViaEmail(props) {
  return JsxRuntime.jsx(ShareMarketingProfileDialog$BaseShareLink, {
    href: ShareURLMakers.makeEmailShareUrl(props.url),
    children: JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsx(IconV5.make, {
          icon: "email",
          className: "text-zinc-500 w-5 h-5"
        }),
        "Share via email"
      ],
      className: "flex gap-4"
    })
  });
}

let ShareViaEmail = {
  make: ShareMarketingProfileDialog$ShareViaEmail
};

function ShareMarketingProfileDialog(props) {
  let onDismiss = props.onDismiss;
  let publicUrl = props.publicUrl;
  return JsxRuntime.jsx(DialogV5.make, {
    title: "Share your marketing profile",
    isOpen: props.isOpen,
    ariaLabel: "Share profile",
    onDismiss: onDismiss,
    size: "XLarge",
    showCloseButton: true,
    children: JsxRuntime.jsx("div", {
      children: JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx(ShareMarketingProfileDialog$ShareOnFacebook, {
                url: publicUrl
              }),
              JsxRuntime.jsx(ShareMarketingProfileDialog$ShareOnTwitter, {
                url: publicUrl
              }),
              JsxRuntime.jsx(ShareMarketingProfileDialog$ShareOnLinkedIn, {
                url: publicUrl
              }),
              JsxRuntime.jsx(ShareMarketingProfileDialog$ShareViaEmail, {
                url: publicUrl
              })
            ]
          }),
          JsxRuntime.jsx("div", {
            children: Stdlib_Option.getOr(Stdlib_Option.map(props.urlDetails, urlDetails => JsxRuntime.jsx(CopyMarketingProfileLinkButton.make, {
              urlDetails: urlDetails
            })), null),
            className: "lg:px-4"
          }),
          JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
              onClick: param => onDismiss(),
              _type: "button",
              children: "Close"
            }),
            className: "flex justify-end"
          })
        ],
        className: "flex flex-col gap-6"
      })
    })
  });
}

let make = ShareMarketingProfileDialog;

exports.BaseShareLink = BaseShareLink;
exports.ShareOnFacebook = ShareOnFacebook;
exports.ShareOnTwitter = ShareOnTwitter;
exports.ShareOnLinkedIn = ShareOnLinkedIn;
exports.ShareViaEmail = ShareViaEmail;
exports.make = make;
/* IconV5 Not a pure module */
